import { Themable } from '@billy/design-system/src/types/themable'
import styled from '@emotion/styled'
import SimpleBar from 'simplebar-react'

export const HiddenTitle = styled.h1`
  display: none;
`

export const PageWrapper = styled(SimpleBar)<Themable>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.ds.colors.base.background};
`

// ModuleLayout pins itself to the full height of its parent and scrolls only its own content, which
// would keep the banner above it pinned. Letting it grow with its content makes the page scroll as one.
export const ModuleLayoutContainer = styled.div`
  position: relative;

  > main {
    height: auto;
    position: relative;
  }
`
